import Vue from 'vue'

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dialogFooterEl = el.querySelector('.el-dialog__footer')
    const dragDom = el.querySelector('.el-dialog')

    if (dialogHeaderEl.style) {
      dialogHeaderEl.style.cursor = 'move'
    }
    if (dialogFooterEl && dialogFooterEl.style) {
      dialogFooterEl.style.cursor = 'move'
    }

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }

      document.onmousemove = function(e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function(e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }

    if (dialogFooterEl) {
      dialogFooterEl.onmousedown = (e) => {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - dialogFooterEl.offsetLeft
        const disY = e.clientY+dragDom.offsetHeight - dialogFooterEl.offsetTop - dialogFooterEl.offsetHeight
  
        // 获取到的值带px 正则匹配替换
        let styL, styT
  
        // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
        if (sty.left.includes('%')) {
          styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
          styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
        } else {
          styL = +sty.left.replace(/\px/g, '')
          styT = +sty.top.replace(/\px/g, '')
        }
  
        document.onmousemove = function(e) {
          // 通过事件委托，计算移动的距离
          const l = e.clientX - disX
          const t = e.clientY - disY
          console.log('====>>>>> yz left: ' + dragDom.style.left + ' top: ' + dragDom.style.top)
          // 移动当前元素
          dragDom.style.left = `${l + styL}px`
          dragDom.style.top = `${t + styT}px`
  
          // 将此时的位置传出去
          // binding.value({x:e.pageX,y:e.pageY})
        }
  
        document.onmouseup = function(e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    }
  },
  update (el, binding) {
    // console.log('111111111111111111111111111 update  ' + binding.value);
    //弹框关闭后，位置重置回来
    if (binding.value == false) {
      const dragDom = el.querySelector('.el-dialog')
      setTimeout(() => {
        dragDom.style.left = '0px'
        dragDom.style.top = '0px'
      }, 200);
    }
  },
  unbind(el) {
    // document.removeEventListener('click');
    // console.log('22222222222222222222222222 unbind')
  }
})
